import type { Area } from 'react-easy-crop'

function loadImage(src: string): Promise<HTMLImageElement> {
  return new Promise((resolve, reject) => {
    const image = new Image()
    image.addEventListener('load', () => resolve(image))
    image.addEventListener('error', (err) => reject(err))
    image.src = src
  })
}

/**
 * Renders the cropped square region into a new canvas and returns a JPEG blob.
 * `outputSize` is the width/height of the output (square).
 */
export async function getCroppedSquareBlob(
  imageSrc: string,
  pixelCrop: Area,
  outputSize = 1024,
  quality = 0.92,
): Promise<Blob> {
  const image = await loadImage(imageSrc)
  const canvas = document.createElement('canvas')
  const ctx = canvas.getContext('2d')
  if (!ctx) throw new Error('Could not get canvas context')

  canvas.width = outputSize
  canvas.height = outputSize

  ctx.drawImage(
    image,
    pixelCrop.x,
    pixelCrop.y,
    pixelCrop.width,
    pixelCrop.height,
    0,
    0,
    outputSize,
    outputSize,
  )

  return new Promise((resolve, reject) => {
    canvas.toBlob(
      (blob) => {
        if (!blob) reject(new Error('Canvas export failed'))
        else resolve(blob)
      },
      'image/jpeg',
      quality,
    )
  })
}

export function croppedBlobToFile(blob: Blob, fileName: string): File {
  return new File([blob], fileName, { type: blob.type })
}
